var map = {
	"./MenuMain/index.js": 1637,
	"./MenuMainDashboard/index.js": 1638,
	"./MenuOrganizationProfile/index.js": 1639,
	"./MenuPersonProfile/index.js": 1640,
	"./MenuProfileDashboard/index.js": 1641,
	"./MenuProjectProfile/index.js": 1642,
	"./MenuResourceProfile/index.js": 1643,
	"./MenuUserProfile/index.js": 1644,
	"./MenuUserProfileContext/index.js": 1645
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3327;


//////////////////
// WEBPACK FOOTER
// ./src/static/menus \.\/.+\/index\.js$
// module id = 3327
// module chunks = 0